var exports = {
  "a": "Box__rtcSnX",
};

module.exports = exports;
